module.exports = __webpack_public_path__ + "static/logo-purplebricks-0745b36cdbd055216cef2e2f66be3640.png";